var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.data ? _vm.data.id : null,
      staticClass: "card-info-item-container"
    },
    [
      _c(
        "div",
        { staticClass: "card-info", style: _vm.cardInfoItemStyling },
        [
          _vm.editingData
            ? _c("InputField", {
                key: _vm.data,
                attrs: {
                  "input-type": "select",
                  value: _vm.data ? _vm.data.id : null,
                  label: _vm.editableLabel,
                  "select-options-list": _vm.editableInputOptions,
                  size: "large",
                  inputFieldContainerStyling: { padding: "0" }
                },
                on: {
                  input: function($event) {
                    return _vm.updateField($event)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card-info-container",
              style: _vm.editingData ? "margin-top: 20px" : ""
            },
            [
              !_vm.editingData
                ? _c(
                    "div",
                    { staticClass: "card-info-item" },
                    [
                      _c("v-icon", { staticClass: "card-icon" }, [
                        _vm._v("manage_accounts")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "card-info-item-label" }, [
                        _vm._v(_vm._s(_vm.$tc("Roles", 2)) + ": ")
                      ]),
                      _vm._v(" "),
                      _vm.data
                        ? _c("span", { staticClass: "card-info-item-value" }, [
                            _vm._v(_vm._s(_vm.data.name) + " ")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-info-item" },
                [
                  _c("v-icon", { staticClass: "card-icon" }, [_vm._v("label")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "card-info-item-label" }, [
                    _vm._v(_vm._s(_vm.$tc("Level", 1)) + ": ")
                  ]),
                  _vm._v(" "),
                  _vm.data
                    ? _c("span", { staticClass: "card-info-item-value" }, [
                        _vm._v(_vm._s(_vm.data.role_level) + " ")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-info-item" },
                [
                  _c("v-icon", { staticClass: "card-icon" }, [
                    _vm._v("apartment")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "card-info-item-label" }, [
                    _vm._v(_vm._s(_vm.$tc("Company", 1)) + ": ")
                  ]),
                  _vm._v(" "),
                  _vm.roleCompany
                    ? _c("span", { staticClass: "card-info-item-value" }, [
                        _vm._v(_vm._s(_vm.roleCompany) + " ")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-info-item" },
                [
                  _c("v-icon", { staticClass: "card-icon" }, [
                    _vm._v("devices")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "card-info-item-label" }, [
                    _vm._v(_vm._s(_vm.$tc("Type", 1)) + ": ")
                  ]),
                  _vm._v(" "),
                  _vm.data
                    ? _c("span", { staticClass: "card-info-item-value" }, [
                        _vm._v(_vm._s(_vm.data.user_type) + " ")
                      ])
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f420aaa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f420aaa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/_Organisms/SingleEditObjectMainInfoRoles.vue
// module id = null
// module chunks = 